import { observable } from "mobx";
import React from "react";
import {montarSelectOption} from "../../../../utils/formatar";
import moment from "moment";
import ImportacaoService from "../../../../services/ImportacaoService";

export default class FiltrosImportacaoStore {

    @observable situacoesFiltros;
    @observable naviosFiltros;

    @observable filtroSituacao;
    @observable filtroNavio;
    @observable filtros;
    @observable dataInicial;
    @observable dataFinal;

    constructor() {
        this.situacoesFiltros = false;
        this.dataInicial = null,//moment().subtract(15, 'day').format("YYYY-MM-DD"),
        this.dataFinal = null, //moment().add(0, 'day').format("YYYY-MM-DD"),
        this.filtros = {
            bl: "",
            ce: ""
        };

        this.service = new ImportacaoService();

        this.carregarFiltros();
    };

    carregarFiltros = () => {
        this.service.listarNavios().then(response => {
            if (response.data) {
                this.naviosFiltros = montarSelectOption("OprOperacao", "NavioViagem", response.data);
            }
        });

        this.situacoesFiltros = [
            { value: "RE", label: "RECEBIDO" },
            { value: "EA", label: "EM ANALISE" },
            { value: "OK", label: "OK" },
            { value: "PE", label: "PENDENTE" },
            { value: "C", label: "CANCELADO" }
        ];
    };

    onChangeFiltro = (dado, event) => {
        if (event) {
            _.set(this.filtros, dado, event.target.value);
        } else {
            _.set(this.filtros, dado, null);
        }
    };

    
    
    onChangeFiltroNavios = value => {
        this.filtroNavio = value!==null ? value : false;
    };
    
    onChangeFiltroSituacao = value => {
        this.filtroSituacao = value!==null ? value : false;
    };
    
    
    onChangeDataInicio = (data) => {
        this.dataInicial = data;
    };

    onChangeDataFim = (data) => {
        this.dataFinal = data;
    };
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/stores/FiltrosImportacaoStore.js